import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Home from './pages/Home'
import Register from './pages/Register'
import Login from './pages/Login'
import ClientMaster from './pages/ClientMaster'
import SubAgentMaster from './pages/SubAgentMaster'
import UserManagement from './pages/UserManagement'
import UserGroups from './pages/UserGroups'
import UserLogs from './pages/UserLogs'
import HospitalReport from './pages/HospitalReport'
import FinancialStatement from './pages/FinancialStatement'
import TemplatesList from './pages/TemplatesList'
import CategoryMaster from './pages/CategoryMaster'
import AddCategory from './pages/AddCategory'
import ReferenceMaster from './pages/ReferenceMaster'
import WorkingCapitalMaster from './pages/WorkingCapitalMaster'
import ProjectPercentageMaster from './pages/ProjectPercentageMaster'
import MarginPercentageMaster from './pages/MarginPercentageMaster'
import BackupReports from './pages/BackupReports'

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        <Route path='/clients' element={<ClientMaster />} />
        <Route path='/sub-agents' element={<SubAgentMaster />} />
        <Route path='/users' element={<UserManagement />} />
        <Route path='/user-groups' element={<UserGroups />} />
        <Route path='/user-logs' element={<UserLogs />} />
        <Route path='/hospital-report' element={<HospitalReport />} />
        <Route path='/financial-statement' element={<FinancialStatement />} />
        <Route path='/working-capital' element={<WorkingCapitalMaster />} />
        <Route path='/templates' element={<TemplatesList />} />
        <Route path='/category-master' element={<CategoryMaster />} />
        <Route path='/add-category' element={<AddCategory />} />
        <Route path='/data-sources' element={<ReferenceMaster type="data_source" title="Data Source Master" />} />
        <Route path='/business-categories' element={<ReferenceMaster type="business_category" title="Business Category Master" />} />
        <Route path='/project-percentage' element={<ProjectPercentageMaster />} />
        <Route path='/margin-setting' element={<MarginPercentageMaster />} />
        <Route path='/backup' element={<BackupReports />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App